export default __webpack_public_path__ + "static/media/plus.a7c9a5e5.svg";